/* ============================================================================
   CROSSBAR KITS · Theme custom JS · v3
   Vanilla JS, no jQuery. Carga via layout/theme.liquid en <head>.
============================================================================ */
(() => {
  'use strict';

  /* Bug fix: guard de ejecución única. theme.liquid carga este archivo en <head>,
     pero varias secciones (main-cart, main-product, etc.) incluyen el mismo
     <script src> otra vez → el IIFE se ejecutaba 2 veces y cada listener quedaba
     duplicado (ej: +/- del bag saltaba 2 unidades por click). */
  if (window.__LD_JS_INIT__) return;
  window.__LD_JS_INIT__ = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  /* Canonical add-on detection for /cart.js line items.
     /cart.js items do NOT include a `tags` field, so we rely only on fields
     that DO exist: properties._addon_for / properties._addon, handle prefix
     'addon-' or 'ld-personalizacion', and product_type. Used by BOTH the
     floating-cart builder and reconcileCartAddons so they always agree. */
  function isLdAddon(it) {
    const props = it.properties || {};
    if (props._addon_for || props._addon) return true;
    const h = (it.handle || '').toLowerCase();
    if (h.indexOf('addon-') === 0) return true;
    if (h === 'ld-personalizacion') return true;
    if (/personalis|customis|patch|addon/i.test(it.product_type || '')) return true;
    return false;
  }

  /* Bug #24 fix: contador global de modales para que el scroll-lock no se
     desactive prematuramente cuando hay 2 modales superpuestos. */
  window.ldLockScroll = function () {
    const depth = parseInt(document.body.dataset.ldModalDepth || '0', 10) + 1;
    document.body.dataset.ldModalDepth = String(depth);
    document.body.style.overflow = 'hidden';
  };
  window.ldUnlockScroll = function () {
    const depth = Math.max(0, parseInt(document.body.dataset.ldModalDepth || '0', 10) - 1);
    document.body.dataset.ldModalDepth = String(depth);
    if (depth === 0) document.body.style.overflow = '';
  };

  /* ---- 1. Bottom sheet ---- */
  function initBottomSheets() {
    const sheets = $$('.ld-bottom-sheet');
    if (!sheets.length) return;
    const backdrop = ensureBackdrop();

    function openSheet(id) {
      const sheet = $(`#${id}`);
      if (!sheet) return;
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeAll() {
      sheets.forEach(s => { s.classList.remove('is-open'); s.setAttribute('aria-hidden', 'true'); });
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    $$('[data-ld-open-sheet]').forEach(t => on(t, 'click', e => { e.preventDefault(); openSheet(t.getAttribute('data-ld-open-sheet')); }));
    $$('.ld-bottom-sheet__close').forEach(b => on(b, 'click', closeAll));
    on(backdrop, 'click', closeAll);
    on(document, 'keydown', e => { if (e.key === 'Escape') closeAll(); });
  }
  function ensureBackdrop() {
    let b = $('.ld-backdrop');
    if (!b) { b = document.createElement('div'); b.className = 'ld-backdrop'; document.body.appendChild(b); }
    return b;
  }

  /* ---- 2. Sticky ATC mobile ---- */
  function initStickyATC() {
    const stickyEl = $('.ld-sticky-atc');
    const triggerEl = $('[data-ld-atc-anchor]') || $('.ld-atc');
    if (!stickyEl || !triggerEl) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) stickyEl.classList.remove('is-visible');
        else if (window.scrollY > 200) stickyEl.classList.add('is-visible');
      });
    }, { threshold: 0 });
    observer.observe(triggerEl);

    const stickyBtn = stickyEl.querySelector('.ld-sticky-atc__btn');
    on(stickyBtn, 'click', e => {
      e.preventDefault();
      const sel = $('.ld-size-btn[aria-checked="true"]');
      if (!sel) {
        $('.ld-size-picker')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      $('[data-ld-atc-main]')?.click();
    });
  }

  /* ---- 3. Variant picker · Size + Versión combinados ----
     v4 · Event delegation para sobrevivir View Transitions (Horizon).
     Lee VARIANTS y refs DOM EN VIVO en cada interacción, nunca en closure cacheado. */
  function getCurrentVariants() {
    const variantsScript = $('script[data-ld-variants]');
    if (!variantsScript) return null;
    try { return JSON.parse(variantsScript.textContent || '[]'); } catch (e) { return null; }
  }
  function getPickedValue(selector) {
    const el = $(selector + '[aria-checked="true"]');
    return el ? (el.dataset.value || el.dataset.version || null) : null;
  }
  function findVariantNow() {
    const VARIANTS = getCurrentVariants();
    if (!VARIANTS) return null;
    const sizeVal = getPickedValue('.ld-size-picker:not([data-ld-size2]) .ld-size-btn');
    const size2Val = getPickedValue('.ld-size-picker[data-ld-size2] .ld-size-btn');
    const verVal = getPickedValue('.ld-version-btn');
    if (!sizeVal) return null;
    if (size2Val) {
      return VARIANTS.find(v => v.option1 === sizeVal && v.option2 === size2Val) || null;
    }
    return VARIANTS.find(v =>
      v.option1 === sizeVal && (!verVal || v.option2 === verVal || v.option2 === null)
    ) || null;
  }
  function applyVariantNow() {
    const v = findVariantNow();
    if (!v) return;
    const hidden = $('input[name="id"][data-ld-variant-input]');
    const atcMain = $('[data-ld-atc-main]');
    const priceEl = $('[data-ld-price]');
    // Also sync the express checkout form (Shop Pay)
    const expressForm = $('#ld-express-form');
    if (hidden) hidden.value = v.id;
    if (expressForm) {
      const xInput = expressForm.querySelector('input[name="id"]');
      if (xInput) xInput.value = v.id;
    }
    function ldActiveCurrency() {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    }
    function ldFormatMoney(cents) {
      const code = ldActiveCurrency();
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + ' ' + code; }
    }
    if (priceEl) {
      const formatted = ldFormatMoney(v.price);
      const priceText = priceEl.childNodes[0];
      if (priceText && priceText.nodeType === 3) priceText.nodeValue = formatted + ' ';
      // Bug #19 fix: re-render <s>compare_at_price</s> by variant
      const existingStrike = priceEl.querySelector('s');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const compFmt = ldFormatMoney(v.compare_at_price);
        if (existingStrike) {
          existingStrike.textContent = compFmt;
        } else {
          const s = document.createElement('s');
          s.style.cssText = 'font-weight: 400; color: var(--ld-gray-text); font-size: 18px; margin-inline-start: 8px;';
          s.textContent = compFmt;
          priceEl.appendChild(s);
        }
      } else if (existingStrike) {
        existingStrike.remove();
      }
    }
    // Bug fix: keep the mobile sticky ATC price in sync with the selected variant
    const stickyPriceEl = $('[data-ld-sticky-price]');
    if (stickyPriceEl) stickyPriceEl.textContent = ldFormatMoney(v.price);
    if (atcMain) {
      const isCB = window.location.hostname.indexOf('crossbarkits') >= 0;
      const labelAdd = isCB ? 'Add to cart' : 'Add to cart';
      const labelOut = 'Sold out';
      const priceStr = ldFormatMoney(v.price);
      const labelOk = v.available ? `${labelAdd} · ${priceStr}` : labelOut;
      const firstChild = atcMain.firstChild;
      if (firstChild && firstChild.nodeType === 3) firstChild.nodeValue = labelOk;
      else atcMain.textContent = labelOk;
      atcMain.disabled = !v.available;
    }
    // Bug #6: hide express checkout (Shop Pay/Apple Pay) if variant is OOS
    const expressWrap = $('.ld-express-checkout');
    if (expressWrap) {
      expressWrap.style.display = v.available ? '' : 'none';
    }
  }
  function pickInGroup(selector, btn) {
    $$(selector).forEach(b => b.setAttribute('aria-checked', 'false'));
    btn.setAttribute('aria-checked', 'true');
  }
  function initSizePicker() {
    // Global delegation once. Idempotent flag.
    if (window.__ldSizeDelegated) return;
    window.__ldSizeDelegated = true;
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.ld-size-btn, .ld-version-btn');
      if (!btn) return;
      // Only inside an active picker (not quick view or other contexts)
      if (btn.getAttribute('aria-disabled') === 'true') return;
      const inSize2 = btn.closest('.ld-size-picker[data-ld-size2]');
      const inSize = btn.closest('.ld-size-picker:not([data-ld-size2])');
      const inVersion = btn.classList.contains('ld-version-btn');
      if (!inSize2 && !inSize && !inVersion) return;
      e.preventDefault();
      if (inSize2) {
        pickInGroup('.ld-size-picker[data-ld-size2] .ld-size-btn', btn);
        // Mark wrapper as touched → stop pulse animation on second selector
        const wrap = btn.closest('[data-ld-pack-size2-wrap]');
        if (wrap) { wrap.setAttribute('data-ld-touched', 'true'); wrap.classList.remove('ld-shake'); }
      }
      else if (inSize) pickInGroup('.ld-size-picker:not([data-ld-size2]) .ld-size-btn', btn);
      else if (inVersion) pickInGroup('.ld-version-btn', btn);
      applyVariantNow();
    });
    // Initial PDP sync in case cv.id does not match selected size
    // Ensure initial national team if no button has aria-checked='true'
    const initSize = $('.ld-size-picker:not([data-ld-size2]) .ld-size-btn[aria-checked="true"]');
    if (!initSize) {
      const firstAvail = $('.ld-size-picker:not([data-ld-size2]) .ld-size-btn:not([aria-disabled="true"])');
      if (firstAvail) firstAvail.setAttribute('aria-checked', 'true');
    }
    const initSize2 = $('.ld-size-picker[data-ld-size2] .ld-size-btn[aria-checked="true"]');
    const has2 = $('.ld-size-picker[data-ld-size2] .ld-size-btn');
    if (has2 && !initSize2) {
      const firstAvail2 = $('.ld-size-picker[data-ld-size2] .ld-size-btn:not([aria-disabled="true"])');
      if (firstAvail2) firstAvail2.setAttribute('aria-checked', 'true');
    }
    const initView = $('.ld-version-btn[aria-checked="true"]');
    const hasView = $('.ld-version-btn');
    if (hasView && !initView) {
      const firstView = $('.ld-version-btn:not([aria-disabled="true"])');
      if (firstView) firstView.setAttribute('aria-checked', 'true');
    }
    applyVariantNow();
  }

  /* ---- 4. Add-ons (Customisation + Patch World Cup) — delegado ---- */
  function syncPersoBox(box) {
    if (!box) return;
    $$('input[type="checkbox"][data-ld-addon]', box).forEach(chk => {
      const key = chk.getAttribute('data-ld-addon');
      const fields = $('[data-ld-addon-fields="' + key + '"]', box);
      if (fields) fields.classList.toggle('is-open', chk.checked);
    });
    box.classList.toggle('is-active', $$('input[type="checkbox"][data-ld-addon]:checked', box).length > 0);
  }
  function initPersonalization() {
    if (window.__ldPersoDelegated) return;
    window.__ldPersoDelegated = true;
    document.addEventListener('change', function (e) {
      const chk = e.target.closest('input[type="checkbox"][data-ld-addon]');
      if (!chk) return;
      const box = chk.closest('.ld-addons');
      syncPersoBox(box);
    });
    // Sync inicial todas las cajas presentes
    $$('.ld-addons').forEach(syncPersoBox);
  }

  /* ---- 5. ATC con add-ons (AJAX SIEMPRE, toast en lugar de redirect) ---- */
  function showCartToast(payload) {
    let toast = document.querySelector('[data-ld-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ld-cart-toast';
      toast.setAttribute('data-ld-cart-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    // Resolve a reliable product image: cart response → active PDP gallery image → any product image
    let src = payload.image || '';
    if (!src) {
      const domImg = $('.ld-gallery2__slide.is-active img') || $('.ld-gallery2__main img') || $('[data-ld-gallery] img') || $('.ld-card__media img');
      if (domImg) src = domImg.currentSrc || domImg.getAttribute('src') || '';
    }
    if (src.indexOf('//') === 0) src = 'https:' + src;                 // protocol-relative → https
    if (src) src += (src.indexOf('?') >= 0 ? '&' : '?') + 'width=160'; // Shopify CDN thumb — keeps the extension intact

    const fallback = `<span class="ld-cart-toast__thumb-fallback" aria-hidden="true"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h14l-1.2 8.4a2 2 0 0 1-2 1.7H8.7a2 2 0 0 1-2-1.7L5 3H2"/><circle cx="9" cy="21" r="1.2"/><circle cx="18" cy="21" r="1.2"/></svg></span>`;
    const thumbImg = src
      ? `<img src="${src}" alt="" class="ld-cart-toast__thumb-img" loading="lazy" onerror="this.remove()">`
      : '';

    toast.innerHTML = `
      <div class="ld-cart-toast__thumb">
        ${fallback}
        ${thumbImg}
        <span class="ld-cart-toast__count" data-ld-toast-count aria-hidden="true">1</span>
      </div>
      <div class="ld-cart-toast__body">
        <span class="ld-cart-toast__head">Your bag</span>
        <span class="ld-cart-toast__title">${payload.title}</span>
        <span class="ld-cart-toast__sub" data-ld-toast-sub></span>
      </div>
      <a href="/cart" class="ld-cart-toast__cta">View cart</a>
      <button type="button" class="ld-cart-toast__x" data-ld-toast-close aria-label="Close">
        <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
      <span class="ld-cart-toast__bar" aria-hidden="true"></span>
    `;
    // Fill count + total from the live cart
    fetch('/cart.js').then(r => r.json()).then(c => {
      const n = c.item_count || 1;
      const cntEl = toast.querySelector('[data-ld-toast-count]');
      const subEl = toast.querySelector('[data-ld-toast-sub]');
      if (cntEl) cntEl.textContent = n;
      if (subEl) {
        let total;
        try { total = new Intl.NumberFormat(undefined, { style: 'currency', currency: c.currency || 'EUR' }).format((c.total_price || 0) / 100); }
        catch (e) { total = ((c.total_price || 0) / 100).toFixed(2) + ' ' + (c.currency || ''); }
        subEl.textContent = n + (n === 1 ? ' item · ' : ' items · ') + total;
      }
    }).catch(function () {});
    // Entrance animation only — no auto-dismiss (closes on × or link click)
    toast.classList.remove('is-open');
    void toast.offsetWidth;
    toast.classList.add('is-open');
    clearTimeout(toast._t);
    toast.querySelectorAll('[data-ld-toast-close]').forEach(b => {
      b.addEventListener('click', () => toast.classList.remove('is-open'));
    });
  }

  function refreshHeaderCount() {
    fetch('/cart.js').then(r => r.json()).then(c => {
      const n = c.item_count || 0;
      let cnt = document.querySelector('.ld-header__cart-count');
      const cartLink = document.querySelector('.ld-header__cart');
      if (n > 0 && cartLink) {
        if (!cnt) {
          cnt = document.createElement('span');
          cnt.className = 'ld-header__cart-count';
          cartLink.appendChild(cnt);
        }
        cnt.textContent = n;
        cnt.classList.add('is-pulse');
        setTimeout(() => cnt.classList.remove('is-pulse'), 480);
      }
      const fc = document.querySelector('[data-floating-count]');
      if (fc) fc.textContent = n;
    }).catch(() => {});
  }

  function initATCForm() {
    // Delegación global UNA sola vez (sobrevive a View Transitions)
    if (window.__ldATCDelegated) return;
    window.__ldATCDelegated = true;
    // Estado para evitar doble submit
    let inflight = false;

    document.addEventListener('submit', async function (e) {
      const form = e.target.closest('form.ld-atc-form');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();
      if (inflight) return;

      // Pack guard: if a second size selector exists and has not been touched, avoid adding default S/S.
      // Mostramos shake + scroll para que el cliente confirme su elección.
      const pack2Wrap = document.querySelector('[data-ld-pack-size2-wrap]');
      if (pack2Wrap && pack2Wrap.getAttribute('data-ld-touched') !== 'true') {
        pack2Wrap.classList.remove('ld-shake');
        // reflow para reiniciar la animación
        void pack2Wrap.offsetWidth;
        pack2Wrap.classList.add('ld-shake');
        try { pack2Wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
        return;
      }

      inflight = true;

      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';
      // Bug #20 fix: guard explícito si btn está disabled o aria-disabled
      if (submitBtn && (submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true')) {
        inflight = false;
        return;
      }
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.loading = 'true';
        submitBtn.setAttribute('aria-disabled', 'true');
      }

      // SIEMPRE recalcular variant antes de enviar (cubre el caso en que el size picker
      // no haya disparado applyVariant por timing de view-transitions)
      try { applyVariantNow(); } catch (_) {}

      // Lectura fresca del input id POR FORM (no global), después del recalculate
      const idInput = form.querySelector('input[name="id"]');
      const variantId = idInput ? parseInt(idInput.value, 10) : 0;
      if (!variantId) {
        if (submitBtn) { submitBtn.disabled = false; delete submitBtn.dataset.loading; submitBtn.textContent = originalText; }
        inflight = false;
        alert('Select a size before adding to bag.');
        return;
      }
      // Scope addons a este form (PDP)
      const pdpRoot = form.closest('[data-ld-pdp-root]') || document;
      const box = pdpRoot.querySelector('.ld-addons') || $('.ld-addons');
      const persoChk = box ? $('input[data-ld-addon="perso"]', box) : null;
      const patchChk = box ? $('input[data-ld-addon="patch"]', box) : null;
      const persoOn = persoChk && persoChk.checked;
      const patchOn = patchChk && patchChk.checked;

      let nombre = '', dorsal = '';
      if (persoOn) {
        nombre = (($('input[data-ld-perso-name]', box) || {}).value || '').trim();
        dorsal = (($('input[data-ld-perso-number]', box) || {}).value || '').trim();
        if (!nombre || !dorsal) {
          alert('Enter a name and number, or untick customisation.');
          if (submitBtn) { submitBtn.disabled = false; delete submitBtn.dataset.loading; submitBtn.textContent = originalText; }
          inflight = false;
          return;
        }
      }

      const lineId = 'pdp-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
      // Bug #15 fix: usar título del producto padre como _addon_for (no literal "Kit")
      const parentTitleEl = $('h1.ld-pdp-title') || $('.ld-pdp__title');
      const parentTitle = (parentTitleEl ? parentTitleEl.textContent : 'Kit').trim();
      const items = [];
      const props = { '_pack_line_id': lineId };
      if (persoOn) props['Customisation'] = nombre + ' · ' + dorsal;
      if (patchOn) props['Patch World Cup 26'] = 'Yes';
      items.push({ id: variantId, quantity: 1, properties: props });

      if (persoOn) {
        const persoVar = parseInt(box.getAttribute('data-perso-variant-id'), 10);
        items.push({ id: persoVar, quantity: 1, properties: { '_pack_line_id': lineId, '_addon_for': parentTitle, 'Name': nombre, 'Number': dorsal } });
      }
      if (patchOn) {
        const patchVar = parseInt(box.getAttribute('data-patch-variant-id'), 10);
        items.push({ id: patchVar, quantity: 1, properties: { '_pack_line_id': lineId, '_addon_for': parentTitle } });
      }

      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          throw new Error(err.description || ('HTTP ' + r.status));
        }
        const data = await r.json();
        const main = (data.items || [])[0] || {};
        showCartToast({
          title: main.product_title || main.title || 'Kit',
          variant_title: main.variant_title || '',
          image: main.image || main.featured_image && main.featured_image.url || ''
        });
        refreshHeaderCount();
        // Disparar evento custom para tracking (TikTok, GA4, etc.)
        try { document.dispatchEvent(new CustomEvent('ld:cart:added', { detail: main })); } catch (_) {}
      } catch (err) {
        console.error(err);
        alert('Could not add to bag: ' + err.message);
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          delete submitBtn.dataset.loading;
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.textContent = originalText;
        }
        inflight = false;
      }
    }, true);
  }

  /* ---- 6. Free shipping progress (cart) ---- */
  function initShippingProgress() {
    const bar = $('.ld-shipping-progress');
    if (!bar) return;
    const threshold = parseFloat(bar.dataset.threshold || '50');
    const subtotal = parseFloat(bar.dataset.subtotal || '0');
    const fill = $('.ld-shipping-progress__fill', bar);
    const msg = $('.ld-shipping-progress__msg', bar);
    const pct = Math.min(100, Math.round((subtotal / threshold) * 100));
    if (fill) fill.style.setProperty('--progress', pct + '%');
    if (msg) {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      const left = Math.max(0, threshold - subtotal);
      let leftFormatted = left.toFixed(2) + ' ' + currency;
      try { leftFormatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(left); } catch (e) {}
      msg.textContent = subtotal >= threshold
        ? 'Free shipping applied.'
        : `Spend ${leftFormatted} more for free shipping.`;
    }
  }

  /* ---- 7. Countdowns ---- */
  function initCountdowns() {
    $$('[data-ld-countdown]').forEach(el => {
      const target = new Date(el.dataset.ldCountdown).getTime();
      if (isNaN(target)) return;
      const update = () => {
        const diff = target - Date.now();
        const spans = el.querySelectorAll('.ld-countdown__unit > span:first-child');
        if (diff <= 0) { el.innerHTML = '<span class="ld-eyebrow">World Cup 26</span>'; return; }
        const d = Math.floor(diff / 86400000),
              h = Math.floor((diff / 3600000) % 24),
              m = Math.floor((diff / 60000) % 60),
              s = Math.floor((diff / 1000) % 60);
        if (spans.length === 4) {
          spans[0].textContent = String(d).padStart(2,'0');
          spans[1].textContent = String(h).padStart(2,'0');
          spans[2].textContent = String(m).padStart(2,'0');
          spans[3].textContent = String(s).padStart(2,'0');
        }
      };
      update();
      setInterval(update, 1000);
    });
  }

  /* ---- 8. Stock counter ---- */
  function initStockCounter() {
    $$('.ld-stock-counter').forEach(el => {
      const sold = parseInt(el.dataset.sold || '0', 10);
      const total = parseInt(el.dataset.total || '200', 10);
      const remaining = Math.max(0, total - sold);
      const pct = total ? Math.min(100, Math.round((sold / total) * 100)) : 0;
      const fill = $('.ld-stock-counter__fill', el);
      if (fill) fill.style.setProperty('--stock-percent', pct + '%');
      const msg = $('.ld-stock-counter__msg', el);
      if (msg) msg.textContent = `${remaining} of ${total} left`;
    });
  }

  /* ---- 9. Cart qty handlers (página /cart) ----
     Bug #8 fix: debounced per-line. 5 clicks rápidos = 1 sola fetch trailing.
     Solo recarga la página después de que el último change.js resuelva. */
  function initCartQty() {
    if (!$$('.ld-cart-item').length) return;
    const lineTimers = {};
    const DEBOUNCE_MS = 380;
    function updateLine(line, quantity) {
      // Cancela cualquier fetch programada para esta línea
      if (lineTimers[line]) clearTimeout(lineTimers[line]);
      lineTimers[line] = setTimeout(() => {
        document.body.style.cursor = 'wait';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        })
          .then(r => {
            if (!r.ok) return r.json().then(err => { throw new Error(err.description || 'HTTP ' + r.status); });
            return r.json();
          })
          .then(() => window.location.reload())
          .catch(err => {
            document.body.style.cursor = '';
            alert('Could not update the bag: ' + (err && err.message ? err.message : ''));
            console.error(err);
          });
      }, DEBOUNCE_MS);
    }
    $$('[data-ld-qty]').forEach(btn => {
      on(btn, 'click', e => {
        e.preventDefault();
        const wrapper = btn.closest('.ld-cart-qty');
        if (!wrapper) return;
        const input = wrapper.querySelector('input[name="updates[]"]');
        if (!input) return;
        const action = btn.getAttribute('data-ld-qty');
        const line = parseInt(input.getAttribute('data-line'), 10);
        let v = parseInt(input.value, 10) || 0;
        v = action === 'inc' ? v + 1 : Math.max(0, v - 1);
        input.value = v;
        updateLine(line, v);
      });
    });
    $$('.ld-cart-qty input[name="updates[]"]').forEach(inp => {
      on(inp, 'change', () => {
        const line = parseInt(inp.getAttribute('data-line'), 10);
        const v = Math.max(0, parseInt(inp.value, 10) || 0);
        updateLine(line, v);
      });
    });
  }

  /* ---- 10b. Floating cart bar global ---- */
  function initFloatingCart() {
    const el = $('[data-component="ld-floating-cart"]');
    if (!el) return;
    const headEl = $('[data-floating-head]', el);
    const subEl = $('[data-floating-sub]', el);
    const countEl = $('[data-floating-count]', el);
    const fillEl = $('[data-floating-fill]', el);

    function fmtMoney(cents, currency) {
      const code = currency || 'EUR';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + ' ' + code; }
    }

    function compute(cart) {
      const subtotalCents = cart.total_price; // minor units
      // Count eligible shirts only; personalisation, numbers and patches are add-ons and do not count
      let itemCount = 0;
      (cart.items || []).forEach(function (it) {
        if (!isLdAddon(it)) itemCount += it.quantity || 0;
      });
      const FREE_SHIP = 6000; // 60 in active market minor units
      let head, sub, pct;

      if (itemCount === 0) {
        return null; // hide
      }

      // Buy 3 eligible shirts, get the 4th eligible shirt free. Discount applies server-side.
      const isCB = window.location.hostname.indexOf('crossbarkits') >= 0;
      const lblUds = (n) => isCB ? (n === 1 ? '1 kit' : n + ' kits') : (n === 1 ? '1 kit' : n + ' kits');
      if (itemCount >= 4) {
        head = 'Free 4th kit target reached';
        sub = `${lblUds(itemCount)} · ${fmtMoney(subtotalCents, cart.currency)}`;
        pct = 100;
      } else if (itemCount === 3) {
        head = 'Add 1 eligible kit for the free 4th';
        sub = `${lblUds(itemCount)} · ${fmtMoney(subtotalCents, cart.currency)}`;
        pct = 75;
      } else if (itemCount === 2) {
        head = 'Add 2 eligible kits for the free 4th';
        sub = `${lblUds(itemCount)} · ${fmtMoney(subtotalCents, cart.currency)}`;
        pct = 50;
      } else {
        head = 'Add 3 eligible kits for the free 4th';
        sub = `${lblUds(itemCount)} · ${fmtMoney(subtotalCents, cart.currency)}`;
        pct = 25;
      }

      // M2: the bundle "buy 3 get the 4th free" nudge takes priority while the
      // customer is progressing toward it (1-3 eligible kits). Only fall back to
      // the free-shipping message once the bundle target is already met (>= 4).
      // (itemCount === 0 returned null earlier.) Keep the progress bar consistent
      // with whichever message is shown.
      if (itemCount >= 4 && subtotalCents < FREE_SHIP) {
        const left = FREE_SHIP - subtotalCents;
        head = `${fmtMoney(left, cart.currency)} away from free shipping`;
        pct = Math.min(100, Math.round((subtotalCents / FREE_SHIP) * 100));
      }

      return { head, sub, pct, itemCount };
    }

    function render(cart) {
      const r = compute(cart);
      if (!r) {
        el.setAttribute('hidden', '');
        return;
      }
      el.removeAttribute('hidden');
      if (headEl) headEl.textContent = r.head;
      if (subEl) subEl.textContent = r.sub;
      if (countEl) countEl.textContent = r.itemCount;
      if (fillEl) fillEl.style.width = r.pct + '%';
    }

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(render)
        .catch(() => {});
    }

    refresh();
    // Re-fetch on visibility change
    on(document, 'visibilitychange', () => { if (!document.hidden) refresh(); });
    // Re-fetch after add-to-cart submissions
    $$('form[action*="/cart/add"], form.ld-atc-form, [data-ld-atc-main]').forEach(form => {
      on(form, 'submit', () => setTimeout(refresh, 600));
    });
    // Slow polling in case the cart changed in another tab
    setInterval(refresh, 60000);
  }

  /* ---- 10. Bottom nav active state ---- */
  function initBottomNav() {
    const path = window.location.pathname;
    $$('.ld-bottom-nav__item').forEach(a => {
      const href = a.getAttribute('href');
      if (!href) return;
      if (href === '/' && path === '/') a.classList.add('is-active');
      else if (href !== '/' && path.startsWith(href)) a.classList.add('is-active');
    });
  }

  /* ---- 11. Size calculator (guía de sizes interactiva) ---- */
  function initSizeCalc() {
    const form = $('[data-component="ld-size-calc"]');
    if (!form) return;
    const out = $('[data-ld-size-output]', form);
    const table = $('[data-component="ld-size-table"]');

    function calc(altura, peso, pecho, fit) {
      // Tabla pivote por altura
      let idx = 1; // M default
      if (altura < 168) idx = 0;        // S
      else if (altura < 177) idx = 1;   // M
      else if (altura < 184) idx = 2;   // L
      else if (altura < 190) idx = 3;   // XL
      else idx = 4;                     // XXL

      // Ajuste por peso (índice de masa relativo)
      // Rangos típicos por size: S<70, M 65-78, L 75-88, XL 85-100, XXL 95+
      if (peso) {
        if (peso < 65 && idx > 0) idx -= 0.5;
        else if (peso > 78 && peso < 92 && idx < 4) idx += 0.5;
        else if (peso >= 92 && peso < 105 && idx < 4) idx += 1;
        else if (peso >= 105 && idx < 4) idx += 1.5;
      }

      // Ajuste por pecho si lo da (más fiable que peso)
      if (pecho) {
        if (pecho < 92) idx = 0;
        else if (pecho < 100) idx = 1;
        else if (pecho < 108) idx = 2;
        else if (pecho < 116) idx = 3;
        else idx = 4;
      }

      // Preferencia de ajuste
      idx += parseFloat(fit || 0);

      // Round y clamp
      idx = Math.max(0, Math.min(4, Math.round(idx)));
      return ['S', 'M', 'L', 'XL', 'XXL'][idx];
    }

    function highlightRow(size) {
      if (!table) return;
      $$('tr[data-size]', table).forEach(tr => {
        tr.classList.toggle('is-recommended', tr.getAttribute('data-size') === size);
      });
    }

    on(form, 'submit', e => {
      e.preventDefault();
      const altura = parseInt(form.altura.value, 10) || 0;
      const peso = parseInt(form.peso.value, 10) || 0;
      const pecho = parseInt(form.pecho.value, 10) || 0;
      const fit = (form.querySelector('input[name="fit"]:checked') || {}).value || '0';

      if (!altura) {
        out.innerHTML = '<span class="ld-size-calc__warn">Enter at least your height.</span>';
        return;
      }

      const size = calc(altura, peso, pecho, fit);
      out.innerHTML = `
        <div class="ld-size-calc__result">
          <span class="ld-eyebrow">Your recommended size</span>
          <strong class="ld-size-calc__big">${size}</strong>
          <span class="ld-size-calc__expl">Check the highlighted row in the table. If you usually order another size, trust your usual fit.</span>
        </div>
      `;
      highlightRow(size);
    });

    // recalcula al cambiar fit si ya hay altura
    $$('input[name="fit"]', form).forEach(r => {
      on(r, 'change', () => { if (form.altura.value) form.dispatchEvent(new Event('submit', { cancelable: true })); });
    });
  }

  /* ---- Newsletter popup · regalo de bienvenida ----
     Movido aquí desde el snippet inline porque el <script> inline del snippet
     no se ejecutaba de forma fiable en el theme Horizon. Este archivo (defer)
     SÍ se ejecuta siempre.
     Timer por SESIÓN: el cronómetro arranca al entrar la 1ª vez y NO se reinicia
     al navegar entre páginas. El popup se muestra una sola vez por sesión. */
  function initNewsletterPopup() {
    const FIRST_DELAY_MS = 4000;     // 1ª sesión: 4s
    const REPEAT_DELAY_MS = 60000;   // sesiones siguientes: 1 minuto
    const SUB_KEY = 'ld_news_subscribed';     // localStorage · bloqueo permanente al suscribirse
    const SEEN_KEY = 'ld_news_seen_count';    // localStorage · nº de sesiones en que se mostró
    const START_KEY = 'ld_news_session_start';// sessionStorage · session start timestamp
    const SHOWN_KEY = 'ld_news_shown';        // sessionStorage · ya mostrado en esta sesión
    const lsGet = (k) => { try { return window.localStorage.getItem(k); } catch (e) { return null; } };
    const lsSet = (k, v) => { try { window.localStorage.setItem(k, v); } catch (e) {} };
    const ssGet = (k) => { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } };
    const ssSet = (k, v) => { try { window.sessionStorage.setItem(k, v); } catch (e) {} };

    const popup = $('[data-ld-news-popup]');
    if (!popup) { console.info('[LD popup] ✗ elemento no encontrado'); return; }
    if (popup.dataset.ldBooted === '1') return;
    popup.dataset.ldBooted = '1';

    const FORCE = /\bpopup=(show|force)\b/i.test(window.location.search);
    let opened = false;

    function popupOpen(skipCount) {
      if (opened) return;
      opened = true;
      popup.removeAttribute('hidden');
      popup.style.display = 'flex';
      popup.style.opacity = '1';
      popup.style.pointerEvents = 'auto';
      popup.classList.add('is-open');
      try { document.body.style.overflow = 'hidden'; } catch (e) {}
      if (!skipCount) {
        ssSet(SHOWN_KEY, '1');  // no volver a mostrar en esta sesión
        lsSet(SEEN_KEY, String((parseInt(lsGet(SEEN_KEY) || '0', 10)) + 1));
      }
      console.info('[LD popup] ✓ ABIERTO');
    }
    function popupClose() {
      opened = false;
      popup.classList.remove('is-open');
      popup.style.opacity = '0';
      popup.style.pointerEvents = 'none';
      try { document.body.style.overflow = ''; } catch (e) {}
      setTimeout(() => { popup.setAttribute('hidden', ''); popup.style.display = ''; }, 280);
    }
    function showSuccess() {
      const fs = popup.querySelector('[data-state="form"]');
      const ok = popup.querySelector('[data-state="success"]');
      if (fs) fs.setAttribute('hidden', '');
      if (ok) ok.removeAttribute('hidden');
      const panel = popup.querySelector('.ld-news-popup__panel');
      if (panel) panel.scrollTop = 0;
      bindCopy();
    }
    function bindCopy() {
      const copyBtn = popup.querySelector('[data-ld-news-copy]');
      if (!copyBtn || copyBtn.dataset.bound) return;
      copyBtn.dataset.bound = '1';
      on(copyBtn, 'click', () => {
        const code = (popup.querySelector('[data-ld-news-code]').textContent || '').trim();
        try { navigator.clipboard.writeText(code); } catch (e) {}
        const orig = copyBtn.textContent;
        copyBtn.textContent = 'Copied';
        copyBtn.classList.add('is-copied');
        setTimeout(() => { copyBtn.textContent = orig; copyBtn.classList.remove('is-copied'); }, 1800);
      });
    }

    const counterEl = popup.querySelector('[data-ld-news-counter]');
    if (counterEl) counterEl.textContent = '152';

    $$('[data-ld-news-close]', popup).forEach((el) => on(el, 'click', (e) => { e.preventDefault(); popupClose(); }));
    on(document, 'keydown', (e) => { if (e.key === 'Escape' && opened) popupClose(); });

    const form = popup.querySelector('#ldNewsCustomerForm');
    const emailInput = popup.querySelector('#ldNewsEmail');
    const errorEl = popup.querySelector('[data-ld-news-error]');
    const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    if (form && emailInput) {
      on(form, 'submit', (e) => {
        // Honeypot: si el campo trampa está relleno, es un bot → cancelar en silencio
        const hp = form.querySelector('input[name="contact[website]"]');
        if (hp && hp.value) { e.preventDefault(); console.info('[LD popup] bot bloqueado por honeypot'); return; }
        if (!isValidEmail((emailInput.value || '').trim())) {
          e.preventDefault();
          if (errorEl) { errorEl.style.display = 'inline-block'; errorEl.removeAttribute('hidden'); }
          emailInput.focus();
        }
      });
    }

    window.ldOpenPopup = () => popupOpen(true);

    if (popup.querySelector('[data-ld-news-posted-flag]')) {
      lsSet(SUB_KEY, '1'); popupOpen(true); showSuccess();
      console.info('[LD popup] estado: alta exitosa');
      return;
    }
    if (popup.querySelector('[data-ld-news-form-error]')) {
      popupOpen(true);
      console.info('[LD popup] estado: error de alta');
      return;
    }
    if (FORCE) { console.info('[LD popup] FORCE'); setTimeout(() => popupOpen(true), 80); return; }
    if (lsGet(SUB_KEY) === '1') { console.info('[LD popup] bloqueado: ya suscrito'); return; }

    /* ¿ya se mostró en esta sesión? → no repetir aunque navegue entre páginas */
    if (ssGet(SHOWN_KEY) === '1') { console.info('[LD popup] already shown this session'); return; }

    /* Session timer: start time is set once in sessionStorage.
       Navigating to another page preserves the start, so the timer does not restart. */
    let sessionStart = parseInt(ssGet(START_KEY) || '0', 10);
    if (!sessionStart) { sessionStart = Date.now(); ssSet(START_KEY, String(sessionStart)); }

    const seen = parseInt(lsGet(SEEN_KEY) || '0', 10);
    const DELAY_MS = seen === 0 ? FIRST_DELAY_MS : REPEAT_DELAY_MS;
    const elapsed = Date.now() - sessionStart;
    const remaining = Math.max(0, DELAY_MS - elapsed);
    console.info('[LD popup] sesiones previas=' + seen + ' · objetivo=' + DELAY_MS + 'ms · transcurrido=' + elapsed + 'ms · abre en ' + remaining + 'ms');
    setTimeout(popupOpen, remaining);
  }

  /* ---- Protección de contenido · bloquea clic derecho y arrastre de imágenes ----
     Disuasorio: impide el menú contextual (copiar imagen / inspeccionar) y el
     drag de imágenes en toda la web. No se activa en el editor de temas. */
  function initContentProtection() {
    if (window.Shopify && window.Shopify.designMode) return;
    // Bug #25 fix: scope a galerías/videos UGC. Permite click derecho en inputs,
    // links, cart, account, etc. sin perjudicar UX legítima.
    document.addEventListener('contextmenu', function (e) {
      const t = e.target;
      if (!t) return;
      // Allow context menu en inputs/textarea/select/links/buttons
      if (t.closest('input, textarea, select, a[href], button')) return;
      // Bloquear solo en zonas protegidas
      if (t.closest('.ld-protected-gallery, .ld-pdp-ugc, .ld-card__media, .ld-gallery2')) {
        e.preventDefault();
      }
    }, false);
    document.addEventListener('dragstart', function (e) {
      if (e.target && e.target.tagName === 'IMG' && e.target.closest('.ld-protected-gallery, .ld-pdp-ugc, .ld-card__media, .ld-gallery2')) {
        e.preventDefault();
      }
    }, false);
  }

  /* ---- Reconcile cart addons ----
     Solo en la página /cart. Resuelve dos problemas:
       1) Huérfanos: si el cliente borra una kit, sus addons (patch/perso)
          se quedan colgando · los detectamos y eliminamos.
       2) Duplicates: if two patches or two customisation add-ons exist for the same kit,
          dejamos solo uno.
     Identifica addons por: propiedad _addon_for · handle 'addon-*' · handle 'ld-personalizacion'.
     Enlaza addon→kit por _pack_line_id (cuando existe) o por _addon_for (título) como fallback.
  */
  async function reconcileCartAddons() {
    const cartForm = document.querySelector('[data-ld-cart-form]');
    if (!cartForm) return;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      if (!cart || !cart.items || !cart.items.length) return;

      const isAddon = isLdAddon;

      const jerseyLineIds = new Set();
      const jerseyMysteryIds = new Set();
      const jerseyTitles = new Set();
      let shirtCount = 0; // M6: count of eligible (non-add-on) shirts in cart
      cart.items.forEach(it => {
        if (isAddon(it)) return;
        shirtCount++;
        const props = it.properties || {};
        if (props._pack_line_id) jerseyLineIds.add(props._pack_line_id);
        if (props._mystery_box) jerseyMysteryIds.add(props._mystery_box);
        if (it.product_title) jerseyTitles.add(it.product_title.toLowerCase());
      });

      const seenKeys = new Set();
      const updates = {};
      let dirty = false;
      let orphans = 0, dupes = 0;

      cart.items.forEach(it => {
        if (!isAddon(it)) return;
        const props = it.properties || {};
        const lineId = props._pack_line_id;
        const mysteryId = props._mystery_box;
        const addonFor = props._addon_for;

        // ¿Hay kit padre? (3 vías: pack lineId, mystery box id, o título)
        let isLinked = true;
        if (lineId) isLinked = jerseyLineIds.has(lineId);
        else if (mysteryId) isLinked = jerseyMysteryIds.has(mysteryId);
        else if (addonFor) {
          // M6: title fallback is tolerant — case-insensitive and bidirectional
          // contains (either string may contain the other).
          isLinked = false;
          const af = addonFor.toLowerCase();
          jerseyTitles.forEach(t => { if (af.indexOf(t) >= 0 || t.indexOf(af) >= 0) isLinked = true; });
        }

        // M6: never delete a paid add-on as an "orphan" while at least one
        // eligible shirt remains in the cart. A title mismatch must NOT silently
        // remove a paid customisation. Only orphan-remove when no shirt remains.
        if (!isLinked && shirtCount === 0) {
          updates[it.key] = 0;
          dirty = true; orphans++;
          return;
        }
        // Dedupe: misma kit-link + mismo variant (patch o perso) → solo 1
        const dedupeKey = (lineId || addonFor || '_') + '::' + it.variant_id;
        if (seenKeys.has(dedupeKey)) {
          updates[it.key] = 0;
          dirty = true; dupes++;
        } else {
          seenKeys.add(dedupeKey);
        }
      });

      if (dirty) {
        console.info('[LD reconcile] orphans=' + orphans + ' duplicates=' + dupes);
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        window.location.reload();
      }
    } catch (e) {
      console.warn('[LD reconcile]', e);
    }
  }

  /* ---- PDP gallery · main image + side thumbnails ---- */
  function initGallery() {
    $$('[data-ld-gallery]').forEach(function (g) {
      const thumbs = $$('[data-ld-thumb]', g);
      const slides = $$('[data-ld-slide]', g);
      if (thumbs.length < 2) return;
      function show(i) {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.ldSlide === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.ldThumb === String(i)); });
      }
      thumbs.forEach(function (t) {
        on(t, 'click', function () { show(t.dataset.ldThumb); });
        on(t, 'mouseenter', function () { show(t.dataset.ldThumb); });
      });
    });
  }

  function init() {
    initGallery();
    initBottomSheets();
    initStickyATC();
    initSizePicker();
    initPersonalization();
    initATCForm();
    initShippingProgress();
    initCountdowns();
    initStockCounter();
    initCartQty();
    initFloatingCart();
    initBottomNav();
    initSizeCalc();
    initNewsletterPopup();
    initContentProtection();
    reconcileCartAddons();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* ----- Re-sync tras View Transitions (Horizon) y BFCache -----
     Las delegaciones globales sobreviven, pero applyVariantNow lee el cv.id inicial
     del nuevo PDP para que precio + ATC text coincidan con la variant correcta. */
  function resyncPDP() {
    try { applyVariantNow(); } catch (_) {}
    $$('.ld-addons').forEach(syncPersoBox);
  }
  // Browser BFCache + history nav
  window.addEventListener('pageshow', resyncPDP);
  window.addEventListener('popstate', resyncPDP);
  // View Transitions API (modern browsers, Horizon theme uses them)
  if ('addEventListener' in window) {
    window.addEventListener('pagereveal', resyncPDP);
  }
  // Fallback: detectar swap del script[data-ld-variants] (cambio de PDP via view-transition)
  let _ldLastVariants = '';
  function _ldCheckVariantsChange() {
    const s = document.querySelector('script[data-ld-variants]');
    const sig = s ? (s.textContent || '').substring(0, 200) : '';
    if (sig && sig !== _ldLastVariants) {
      _ldLastVariants = sig;
      resyncPDP();
    }
  }
  _ldCheckVariantsChange();
  // Debounced observer · solo refresca si el VARIANTS json cambió
  let _ldDebounce = null;
  const variantsObserver = new MutationObserver(function () {
    if (_ldDebounce) cancelAnimationFrame(_ldDebounce);
    _ldDebounce = requestAnimationFrame(_ldCheckVariantsChange);
  });
  const main = document.querySelector('#MainContent') || document.body;
  if (main) variantsObserver.observe(main, { childList: true, subtree: false });
})();


/* Crossbarkits global protection + product share */
(function(){
  if (window.__cbGlobalGuards) return;
  window.__cbGlobalGuards = true;
  document.addEventListener('contextmenu', function(e){ e.preventDefault(); }, {capture:true});
  document.addEventListener('dragstart', function(e){ if (e.target && e.target.closest && e.target.closest('img, video')) e.preventDefault(); }, {capture:true});
  document.addEventListener('click', async function(e){
    const btn = e.target.closest('[data-ld-share-product]');
    if (!btn) return;
    e.preventDefault();
    const data = { title: document.title, text: document.title, url: window.location.href };
    try {
      if (navigator.share) await navigator.share(data);
      else { await navigator.clipboard.writeText(window.location.href); btn.querySelector('span').textContent = 'Link copied'; setTimeout(()=>{ const s=btn.querySelector('span'); if(s) s.textContent='Share product'; }, 1800); }
    } catch(_) {}
  });
})();
